class Shift4LinkTokenController {
  constructor(Authentication, IntegrationService, $state, $location, $window) {
    'ngInject';

    Object.assign(this, { Authentication, IntegrationService, $state, $location, $window });
  }

  async $onInit() {
    const goToIntegrations = (type) => this.$state.go('settings', { tab: 'integrations', type });

    const { linkToken } = this.$state.params;
    const integration = await this.IntegrationService.getIntegrationByPlatform('shift4');

    try {
      await this.IntegrationService.oauth(integration, linkToken, 'shift4');
      return;
    } finally {
      goToIntegrations();
    }
  }
}

export default {
  template: `
    <div class="integration-link-token__container">
      <sling-loader></sling-loader>
    </div>
  `,
  controller: Shift4LinkTokenController,
};
